var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.targetViewComponent,{tag:"component",attrs:{"service-type":_vm.serviceType,"target":_vm.target},on:{"clearErrors":_vm.clearErrors},model:{value:(_vm.selectedTarget),callback:function ($$v) {_vm.selectedTarget=$$v},expression:"selectedTarget"}})
}
var staticRenderFns = []

export { render, staticRenderFns }